import { render } from "./trading-accounts.vue?vue&type=template&id=efce10fc"
import script from "./trading-accounts.vue?vue&type=script&lang=js"
export * from "./trading-accounts.vue?vue&type=script&lang=js"

import "./trading-accounts.vue?vue&type=style&index=0&id=efce10fc&lang=css"

import exportComponent from "/home/copycrack-client-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__